import * as React from 'react';

import { cn } from '../../lib/cn';

/** Props di {@link Input}: nessuna prop custom, solo gli attributi HTML standard di `<input>` (type, value, placeholder, ecc.). */
export interface InputProps extends React.ComponentProps<'input'> {}

/** Campo di testo standard dell'app (usato direttamente o tramite {@link FormField} per form con validazione). */
const Input = React.forwardRef<HTMLInputElement, InputProps>(
	({ className, type, ...props }, ref) => {
		return (
			<input
				type={type}
				className={cn(
					'flex h-9 w-full rounded-[7px] border border-border bg-card px-2.5 py-1.5 text-xs text-foreground ring-offset-background file:border-0 file:bg-transparent file:text-xs file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:border-accent focus-visible:ring-0 disabled:cursor-not-allowed disabled:opacity-50 transition-colors',
					className,
				)}
				ref={ref}
				{...props}
			/>
		);
	},
);
Input.displayName = 'Input';

export { Input };
